/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { UiFilterSortADefaultIcon16Light } from './UiFilterSortADefaultIcon16Light';
import { UiFilterSortADefaultIcon16Regular } from './UiFilterSortADefaultIcon16Regular';
import { UiFilterSortADefaultIcon16Solid } from './UiFilterSortADefaultIcon16Solid';
import { UiFilterSortADefaultIcon20Light } from './UiFilterSortADefaultIcon20Light';
import { UiFilterSortADefaultIcon20Regular } from './UiFilterSortADefaultIcon20Regular';
import { UiFilterSortADefaultIcon20Solid } from './UiFilterSortADefaultIcon20Solid';
import { UiFilterSortADefaultIcon24Regular } from './UiFilterSortADefaultIcon24Regular';
import { UiFilterSortADefaultIcon24Solid } from './UiFilterSortADefaultIcon24Solid';
import { UiFilterSortADefaultIcon32Regular } from './UiFilterSortADefaultIcon32Regular';
import { UiFilterSortADefaultIcon64Regular } from './UiFilterSortADefaultIcon64Regular';
var sizes = {
    16: {
        light: UiFilterSortADefaultIcon16Light,
        regular: UiFilterSortADefaultIcon16Regular,
        solid: UiFilterSortADefaultIcon16Solid,
    },
    20: {
        light: UiFilterSortADefaultIcon20Light,
        regular: UiFilterSortADefaultIcon20Regular,
        solid: UiFilterSortADefaultIcon20Solid,
    },
    24: {
        regular: UiFilterSortADefaultIcon24Regular,
        solid: UiFilterSortADefaultIcon24Solid,
    },
    32: {
        regular: UiFilterSortADefaultIcon32Regular,
    },
    64: {
        regular: UiFilterSortADefaultIcon64Regular,
    },
};
export var UiFilterSortADefaultIcon = forwardRef('UiFilterSortADefaultIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
